import Vue from "vue";
import VueRouter from "vue-router";
import appRoute from "./appRoute";
import activityRoute from "./activityRoute";
import miniProgram from "./miniProgramRoute";
import atcRoute from "./timonialsRouter";
import liveRouter from "./liveRouter";
import answerRouter from "./answerRouter";
import accountingRoute from "./accountingRouter";
import basicPage from "./basicPage";
import orderRouter from "./orderRouter";
import featuredRouter from "./featuredRouter";
import shareRouter from "./shareRouter";
import robotPhoneRouter from "./robotPhoneRoute";
import feedBack from "./feedBack";
let Child = {
	atcRoute,
	accountingRoute
};
function transformRoutes(routes, prefix = "app") {
	if (!routes || !routes.length) return [];
	return routes.map(item => {
		let { name, title, child, params } = item;
		let pathPrefix = prefix == "app" ? "" : prefix;
		const paramsName = params ? params : name;
		let obj = {
			path: item.grade ? `/${paramsName}` : `/${pathPrefix}/${paramsName}`,
			...item,
			name: `${name}`,
			meta: {
				title
			},
			component: () => import(`@/pages/${prefix}/${name}`),
			children: !!child
				? [...transformRoutes(Child[`${child}Route`], `${pathPrefix}/${child}`)]
				: []
		};
		if (item.children) obj.children = item.children;
		return obj;
	});
}
let routes = [
	{
		path: "*",
		redirect: { name: "index" }
	},
	{
		path: "/",
		redirect: { name: "index" }
	},
	{
		path: "/test/*",
		redirect: { name: "test" }
	},
	...transformRoutes(appRoute),
	...transformRoutes(activityRoute, "activity"),
	...transformRoutes(miniProgram, "miniProgram"),
	...transformRoutes(liveRouter, "liveLecturer"),
	...transformRoutes(answerRouter, "answer"),
	...transformRoutes(basicPage, "basicPage"),
	...transformRoutes(orderRouter, "orderPay"),
	...transformRoutes(featuredRouter, "featured"),
	...transformRoutes(shareRouter, "share"),
	...transformRoutes(robotPhoneRouter, "robotPhone"),
	...transformRoutes(feedBack, "feedBack")
];
Vue.use(VueRouter);
export function createRouter() {
	return new VueRouter({
		routes,
		mode: "history",
		base: "/yatikuweb/",
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) return savedPosition;
			else {
				return {
					x: 0,
					y: 0
				};
			}
			if (to.hash) {
				return {
					// 通过 to.hash 的值來找到对应的元素
					selector: to.hash
				};
			}
		}
	});
}



// WEBPACK FOOTER //
// ./src/route/index.js